<shakespeare-spinning-loader class="spinner" style="margin: 0;" *ngIf="submitting"></shakespeare-spinning-loader>
